import { ContactsDTO } from "../domain/models/dto/ContactsDTO";
import { IContacts } from "../domain/models/Contacts";
import { ContactsService } from "../domain/services/ContactsService";
import { ContactsMapper } from "../mappers/ContactsMapper";
import { RemoveResponse } from "../types/ApiResults";
import { BaseServiceImpl } from "./BaseServiceImpl";

export class ContactsServiceImpl extends BaseServiceImpl implements ContactsService {
    static _instance: ContactsService;
    private contactsMapper = new ContactsMapper();
    private readonly contactsEndpoint = "/api/v1/contacts";

    private constructor() {
        super();
    }

    static getInstance(): ContactsService {
        if (!ContactsServiceImpl._instance) {
            ContactsServiceImpl._instance = new ContactsServiceImpl();
        }
        return ContactsServiceImpl._instance;
    }

    instantiate(entity: IContacts): IContacts {
        return this.contactsMapper.fromDTO(entity);
    }

    async getContacts(): Promise<IContacts | null> {
        try {
            const dto = await super.get<ContactsDTO>(this.contactsEndpoint);
            if (!dto) return null;
            return this.contactsMapper.fromDTO(dto);
        } catch (err) {
            console.log("Error in ContactsServiceImpl.getContacts");
            console.log(err);
            return null;
        }
    }

    async createOrUpdate(dto: IContacts): Promise<IContacts | null> {
        try {
            const encodedDto = this.contactsMapper.toDTO(dto);
            if (dto.id) {
                return this.patch(`${this.contactsEndpoint}/${dto.id}`, encodedDto);
            }

            return this.post(this.contactsEndpoint, encodedDto);
        } catch (err) {
            console.log("Error in ContactsServiceImpl.createOrUpdate");
            console.log(err);
            return null;
        }
    }

    async deleteById(id: string): Promise<RemoveResponse> {
        try {
            if (!id) return { status: false };
            return super.delete(`${this.contactsEndpoint}/${id}`);
        } catch (err) {
            console.log("Error in ContactsServiceImpl.deleteById");
            console.log(err);
            return { status: false };
        }
    }
}

export function contactsServiceFactory(): ContactsService {
    return ContactsServiceImpl.getInstance();
}

